import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import QuickReplyTemplate from './QuickReplyTemplate'
import { lang } from '../../assets/lang'

export default class QuickReplyComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.QUICK_REPLY)

    this.data.component = QuickReplyTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.QUICK_REPLY
    this.setConnection()

    const quickReplyInput = new Rete.Input(CONST_SOCKET.QUICK_REPLY_INPUT, lang.quick_reply_socket_input_reply, this.socket.quickReplyInput, false)
    const quickReplyOutput = new Rete.Output(CONST_SOCKET.QUICK_REPLY_OUTPUT, lang.quick_reply_socket_output, this.socket.quickReplyOutput, false)
    const quickReplyOutputSequence = new Rete.Output(CONST_SOCKET.QUICK_REPLY_OUTPUT_SEQUENCE, lang.quick_reply_socket_output_sequence, this.socket.quickReplyOutputSequence, false)

    return node
      .addInput(quickReplyInput)
      .addOutput(quickReplyOutput)
      .addOutput(quickReplyOutputSequence)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.QUICK_REPLY_OUTPUT] = node.data
  }

  setConnection() {
    // QuickReply may be connected to:
    this.socket.quickReplyOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.quickReplyOutput.combineWith(this.socket.openaiInput)
    this.socket.quickReplyOutput.combineWith(this.socket.carouselInput)
    this.socket.quickReplyOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.quickReplyOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.quickReplyOutput.combineWith(this.socket.videoInput)
      this.socket.quickReplyOutput.combineWith(this.socket.audioInput)
      this.socket.quickReplyOutput.combineWith(this.socket.fileInput)
      // this.socket.quickReplyOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.quickReplyOutput.combineWith(this.socket.rcnInput)
    }

    this.socket.quickReplyOutput.combineWith(this.socket.ecommerceInput)
    this.socket.quickReplyOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.quickReplyOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.quickReplyOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.quickReplyOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.quickReplyOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.quickReplyOutput.combineWith(this.socket.conditionInput)
    }

  }
}